export const products = [
  // Women (5)
  {
    id: "1",
    name: "Women's Classic Fit Cotton T-Shirt",
    brand: "Style & Co",
    category: "Women",
    price: 29.5,
    salePrice: 19.99,
    image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400",
    rating: 4.5,
    reviews: 1243,
    description: "Soft cotton t-shirt with a classic fit. Perfect for everyday wear.",
    sizes: ["XS", "S", "M", "L", "XL", "XXL"],
    colors: [
      { name: "White", hex: "#FFFFFF" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "2",
    name: "Women's Wool Blend Peacoat",
    brand: "Calvin Klein",
    category: "Women",
    price: 225.0,
    salePrice: 159.99,
    image: "https://images.unsplash.com/photo-1539533018447-63fcce2678e3?w=400",
    rating: 4.5,
    reviews: 654,
    description: "Classic wool blend peacoat with double-breasted front.",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: [{ name: "Black", hex: "#000000" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "3",
    name: "Floral Midi Wrap Dress",
    brand: "INC International Concepts",
    category: "Women",
    price: 89.5,
    image: "https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=400",
    rating: 4.6,
    reviews: 412,
    description: "Lightweight wrap dress with a flattering silhouette.",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: [
      { name: "Navy Floral", hex: "#1a237e" },
      { name: "Rose", hex: "#c2185b" },
    ],
    inStock: true,
    badge: "NEW",
  },
  {
    id: "4",
    name: "High-Rise Skinny Jeans",
    brand: "Levi's",
    category: "Women",
    price: 79.5,
    salePrice: 59.99,
    image: "https://images.unsplash.com/photo-1541099649105-f69ad21a324c?w=400",
    rating: 4.7,
    reviews: 2102,
    description: "Stretch denim with a high-rise waist and skinny leg.",
    sizes: ["24", "26", "28", "30", "32"],
    colors: [
      { name: "Blue", hex: "#3949ab" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "5",
    name: "Cashmere Crewneck Sweater",
    brand: "Charter Club",
    category: "Women",
    price: 129.0,
    image: "https://images.unsplash.com/photo-1576566588028-4147f3842f27?w=400",
    rating: 4.8,
    reviews: 891,
    description: "Luxuriously soft cashmere blend crewneck.",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: [
      { name: "Camel", hex: "#c19a6b" },
      { name: "Gray", hex: "#757575" },
    ],
    inStock: true,
    badge: "BEST SELLER",
  },

  // Men (5)
  {
    id: "6",
    name: "Men's Slim Fit Stretch Jeans",
    brand: "Levi's",
    category: "Men",
    price: 69.5,
    salePrice: 49.99,
    image: "https://images.unsplash.com/photo-1542272604-787c3835535d?w=400",
    rating: 4.7,
    reviews: 856,
    description: "Classic slim fit jeans with stretch comfort.",
    sizes: ["28", "30", "32", "34", "36", "38"],
    colors: [
      { name: "Dark Wash", hex: "#1a237e" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "7",
    name: "Men's Oxford Dress Shirt",
    brand: "Tommy Hilfiger",
    category: "Men",
    price: 69.5,
    image: "https://images.unsplash.com/photo-1602810318383-e386cc2a3ccf?w=400",
    rating: 4.5,
    reviews: 723,
    description: "Crisp cotton oxford with button-down collar.",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: [
      { name: "White", hex: "#FFFFFF" },
      { name: "Light Blue", hex: "#90caf9" },
    ],
    inStock: true,
    badge: "NEW",
  },
  {
    id: "8",
    name: "Men's Quilted Bomber Jacket",
    brand: "Michael Kors",
    category: "Men",
    price: 198.0,
    salePrice: 149.99,
    image: "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=400",
    rating: 4.6,
    reviews: 334,
    description: "Lightweight quilted bomber with zip front.",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: [{ name: "Black", hex: "#000000" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "9",
    name: "Men's Chino Shorts",
    brand: "Club Room",
    category: "Men",
    price: 49.5,
    image: "https://images.unsplash.com/photo-1591195853828-11db59a44f6b?w=400",
    rating: 4.4,
    reviews: 567,
    description: "Classic fit chino shorts with stretch waistband.",
    sizes: ["30", "32", "34", "36", "38"],
    colors: [
      { name: "Khaki", hex: "#c2b280" },
      { name: "Navy", hex: "#0d47a1" },
    ],
    inStock: true,
  },
  {
    id: "10",
    name: "Men's Fleece Pullover Hoodie",
    brand: "Nike",
    category: "Men",
    price: 65.0,
    image: "https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=400",
    rating: 4.8,
    reviews: 1520,
    description: "Soft fleece hoodie with kangaroo pocket.",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: [
      { name: "Gray", hex: "#9E9E9E" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
    badge: "BEST SELLER",
  },

  // Kids (5)
  {
    id: "11",
    name: "Kids' Graphic Print Hoodie",
    brand: "Nike",
    category: "Kids",
    price: 45.0,
    image: "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=400",
    rating: 4.8,
    reviews: 432,
    description: "Comfortable cotton blend hoodie with fun graphic print.",
    sizes: ["4", "5", "6", "7", "8", "10", "12"],
    colors: [
      { name: "Gray", hex: "#9E9E9E" },
      { name: "Pink", hex: "#E91E63" },
    ],
    inStock: true,
    badge: "NEW",
  },
  {
    id: "12",
    name: "Girls' Tulle Party Dress",
    brand: "Rare Editions",
    category: "Kids",
    price: 58.0,
    salePrice: 39.99,
    image: "https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?w=400",
    rating: 4.7,
    reviews: 289,
    description: "Sparkly tulle dress perfect for parties and photos.",
    sizes: ["4", "5", "6", "7", "8", "10"],
    colors: [{ name: "Blush", hex: "#f8bbd0" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "13",
    name: "Boys' Cargo Jogger Pants",
    brand: "Epic Threads",
    category: "Kids",
    price: 36.0,
    image: "https://images.unsplash.com/photo-1519238263530-99bdd11df2ea?w=400",
    rating: 4.5,
    reviews: 178,
    description: "Durable joggers with cargo pockets and elastic cuffs.",
    sizes: ["4", "5", "6", "7", "8", "10", "12", "14"],
    colors: [
      { name: "Olive", hex: "#558b2f" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
  },
  {
    id: "14",
    name: "Kids' Light-Up Sneakers",
    brand: "Skechers",
    category: "Kids",
    price: 54.0,
    image: "https://images.unsplash.com/photo-1514986888952-281cd1a2e64f?w=400",
    rating: 4.6,
    reviews: 901,
    description: "Fun light-up soles with easy hook-and-loop closure.",
    sizes: ["11", "12", "13", "1", "2", "3"],
    colors: [
      { name: "Blue/Red", hex: "#1565c0" },
      { name: "Pink", hex: "#e91e63" },
    ],
    inStock: true,
    badge: "NEW",
  },
  {
    id: "15",
    name: "Baby 5-Piece Bodysuit Set",
    brand: "First Impressions",
    category: "Kids",
    price: 32.0,
    image: "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=400",
    rating: 4.9,
    reviews: 1204,
    description: "Soft cotton bodysuits with snap closures.",
    sizes: ["0-3M", "3-6M", "6-9M", "9-12M"],
    colors: [{ name: "Assorted", hex: "#eceff1" }],
    inStock: true,
    badge: "BEST SELLER",
  },

  // Home (5)
  {
    id: "16",
    name: "Luxury Queen Sheet Set",
    brand: "Hotel Collection",
    category: "Home",
    price: 189.0,
    salePrice: 129.99,
    image: "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=400",
    rating: 4.6,
    reviews: 2103,
    description: "600-thread count Egyptian cotton sheet set.",
    sizes: ["Twin", "Full", "Queen", "King"],
    colors: [{ name: "White", hex: "#FFFFFF" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "17",
    name: "Martha Stewart Dutch Oven",
    brand: "Martha Stewart",
    category: "Home",
    price: 149.99,
    image: "https://images.unsplash.com/photo-1556911220-bff31c812dba?w=400",
    rating: 4.8,
    reviews: 756,
    description: "Enameled cast iron 5.5-qt Dutch oven.",
    sizes: ["One Size"],
    colors: [
      { name: "Red", hex: "#c62828" },
      { name: "Blue", hex: "#1565c0" },
    ],
    inStock: true,
    badge: "NEW",
  },
  {
    id: "18",
    name: "Velvet Throw Pillow Set (2-Pack)",
    brand: "Lacoste",
    category: "Home",
    price: 48.0,
    image: "https://images.unsplash.com/photo-1584100936595-c0884e9b69ce?w=400",
    rating: 4.4,
    reviews: 445,
    description: "Plush velvet covers with feather inserts.",
    sizes: ["18x18", "20x20"],
    colors: [
      { name: "Emerald", hex: "#2e7d32" },
      { name: "Gold", hex: "#f9a825" },
    ],
    inStock: true,
  },
  {
    id: "19",
    name: "Spa Waffle Towel Bundle",
    brand: "Hotel Collection",
    category: "Home",
    price: 79.5,
    salePrice: 59.99,
    image: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=400",
    rating: 4.7,
    reviews: 623,
    description: "Six-piece towel set in quick-dry waffle weave.",
    sizes: ["Bath", "Hand", "Wash"],
    colors: [{ name: "White", hex: "#FFFFFF" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "20",
    name: "Modern Ceramic Table Lamp",
    brand: "Safavieh",
    category: "Home",
    price: 89.0,
    image: "https://images.unsplash.com/photo-1507473885765-e6ed057f782c?w=400",
    rating: 4.5,
    reviews: 312,
    description: "Matte ceramic base with linen drum shade.",
    sizes: ["One Size"],
    colors: [
      { name: "White", hex: "#fafafa" },
      { name: "Black", hex: "#212121" },
    ],
    inStock: true,
  },

  // Shoes (5)
  {
    id: "21",
    name: "Air Max Running Sneakers",
    brand: "Nike",
    category: "Shoes",
    price: 160.0,
    image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400",
    rating: 4.9,
    reviews: 3421,
    description: "Premium running sneakers with Air Max cushioning.",
    sizes: ["6", "7", "8", "9", "10", "11", "12"],
    colors: [{ name: "Black/White", hex: "#000000" }],
    inStock: true,
    badge: "BEST SELLER",
  },
  {
    id: "22",
    name: "Men's Leather Oxford Shoes",
    brand: "Cole Haan",
    category: "Shoes",
    price: 198.0,
    salePrice: 149.99,
    image: "https://images.unsplash.com/photo-1614252235316-8c857d38b5f4?w=400",
    rating: 4.7,
    reviews: 432,
    description: "Genuine leather oxford shoes with cushioned insole.",
    sizes: ["7", "8", "9", "10", "11", "12"],
    colors: [{ name: "Black", hex: "#000000" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "23",
    name: "Women's Block Heel Sandals",
    brand: "INC International Concepts",
    category: "Shoes",
    price: 79.5,
    image: "https://images.unsplash.com/photo-1543163521-1bf539c55dd2?w=400",
    rating: 4.5,
    reviews: 887,
    description: "Comfortable block heel with ankle strap.",
    sizes: ["5", "6", "7", "8", "9", "10"],
    colors: [
      { name: "Nude", hex: "#d7ccc8" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
  },
  {
    id: "24",
    name: "Adidas Ultraboost Running",
    brand: "adidas",
    category: "Shoes",
    price: 190.0,
    salePrice: 159.99,
    image: "https://images.unsplash.com/photo-1608231387042-66d1773070a5?w=400",
    rating: 4.8,
    reviews: 2789,
    description: "Responsive Boost midsole with Primeknit upper.",
    sizes: ["6", "7", "8", "9", "10", "11", "12"],
    colors: [
      { name: "Core Black", hex: "#000000" },
      { name: "White", hex: "#FFFFFF" },
    ],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "25",
    name: "UGG Classic Mini Boots",
    brand: "UGG",
    category: "Shoes",
    price: 170.0,
    image: "https://images.unsplash.com/photo-1603487742130-0b2b3dd0a8b5?w=400",
    rating: 4.9,
    reviews: 4102,
    description: "Sheepskin lining with durable outsole.",
    sizes: ["5", "6", "7", "8", "9", "10", "11"],
    colors: [
      { name: "Chestnut", hex: "#8d6e63" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
    badge: "BEST SELLER",
  },

  // Handbags (5)
  {
    id: "26",
    name: "Leather Crossbody Bag",
    brand: "Michael Kors",
    category: "Handbags",
    price: 298.0,
    salePrice: 199.99,
    image: "https://images.unsplash.com/photo-1548036328-c9fa89d128fa?w=400",
    rating: 4.7,
    reviews: 876,
    description: "Genuine leather crossbody bag with adjustable strap.",
    sizes: ["One Size"],
    colors: [{ name: "Black", hex: "#000000" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "27",
    name: "Large Leather Tote",
    brand: "Coach",
    category: "Handbags",
    price: 395.0,
    image: "https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=400",
    rating: 4.8,
    reviews: 543,
    description: "Roomy tote with zip top and interior pockets.",
    sizes: ["One Size"],
    colors: [
      { name: "Brown", hex: "#5d4037" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
    badge: "NEW",
  },
  {
    id: "28",
    name: "Quilted Chain Shoulder Bag",
    brand: "Guess",
    category: "Handbags",
    price: 98.0,
    salePrice: 74.99,
    image: "https://images.unsplash.com/photo-1566150905458-1bf1fc113f0d?w=400",
    rating: 4.4,
    reviews: 421,
    description: "Quilted faux leather with gold-tone chain strap.",
    sizes: ["One Size"],
    colors: [{ name: "Black", hex: "#000000" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "29",
    name: "Straw Summer Clutch",
    brand: "INC International Concepts",
    category: "Handbags",
    price: 49.5,
    image: "https://images.unsplash.com/photo-1594223274512-ad4803739b7c?w=400",
    rating: 4.3,
    reviews: 198,
    description: "Woven straw clutch with magnetic closure.",
    sizes: ["One Size"],
    colors: [{ name: "Natural", hex: "#d7ccc8" }],
    inStock: true,
  },
  {
    id: "30",
    name: "Mini Backpack Purse",
    brand: "Steve Madden",
    category: "Handbags",
    price: 78.0,
    image: "https://images.unsplash.com/photo-1622560463248-7f71329b364e?w=400",
    rating: 4.6,
    reviews: 667,
    description: "Convertible mini backpack with top handle.",
    sizes: ["One Size"],
    colors: [
      { name: "Blush", hex: "#f48fb1" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
    badge: "NEW",
  },

  // Jewelry (5)
  {
    id: "31",
    name: "Diamond Pendant Necklace",
    brand: "Kay Jewelers",
    category: "Jewelry",
    price: 499.0,
    salePrice: 349.99,
    image: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=400",
    rating: 4.8,
    reviews: 543,
    description: "14K white gold diamond pendant necklace.",
    sizes: ["One Size"],
    colors: [{ name: "White Gold", hex: "#E8E8E8" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "32",
    name: "Gold Hoop Earrings",
    brand: "Macy's",
    category: "Jewelry",
    price: 125.0,
    image: "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=400",
    rating: 4.6,
    reviews: 892,
    description: "14K yellow gold medium hoops with snap closure.",
    sizes: ["25mm", "35mm"],
    colors: [{ name: "Yellow Gold", hex: "#ffd54f" }],
    inStock: true,
  },
  {
    id: "33",
    name: "Sterling Silver Tennis Bracelet",
    brand: "Giani Bernini",
    category: "Jewelry",
    price: 89.0,
    salePrice: 69.99,
    image: "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=400",
    rating: 4.5,
    reviews: 334,
    description: "Cubic zirconia line bracelet in sterling silver.",
    sizes: ["7 in", "7.5 in", "8 in"],
    colors: [{ name: "Silver", hex: "#b0bec5" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "34",
    name: "Men's Signet Ring",
    brand: "Esquire Men's Jewelry",
    category: "Jewelry",
    price: 199.0,
    image: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=400",
    rating: 4.4,
    reviews: 156,
    description: "Stainless steel signet ring with brushed finish.",
    sizes: ["9", "10", "11", "12"],
    colors: [{ name: "Silver", hex: "#90a4ae" }],
    inStock: true,
  },
  {
    id: "35",
    name: "Pearl Strand Necklace",
    brand: "Belle de Mer",
    category: "Jewelry",
    price: 275.0,
    image: "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=400",
    rating: 4.7,
    reviews: 278,
    description: "Cultured freshwater pearls with 14K gold clasp.",
    sizes: ["16 in", "18 in"],
    colors: [{ name: "White Pearl", hex: "#fffde7" }],
    inStock: true,
    badge: "NEW",
  },

  // Beauty (5)
  {
    id: "36",
    name: "Vitamin C Brightening Serum",
    brand: "Clinique",
    category: "Beauty",
    price: 62.0,
    image: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=400",
    rating: 4.6,
    reviews: 1876,
    description: "Potent vitamin C serum that brightens skin tone.",
    sizes: ["30ml", "50ml"],
    colors: [],
    inStock: true,
    badge: "NEW",
  },
  {
    id: "37",
    name: "MAC Matte Lipstick",
    brand: "MAC",
    category: "Beauty",
    price: 22.0,
    image: "https://images.unsplash.com/photo-1586495777744-4413f21062fa?w=400",
    rating: 4.8,
    reviews: 4521,
    description: "Iconic creamy matte lipstick, long-wearing.",
    sizes: ["One Size"],
    colors: [
      { name: "Ruby Woo", hex: "#b71c1c" },
      { name: "Velvet Teddy", hex: "#8d6e63" },
    ],
    inStock: true,
    badge: "BEST SELLER",
  },
  {
    id: "38",
    name: "Estée Lauder Advanced Night Repair",
    brand: "Estée Lauder",
    category: "Beauty",
    price: 105.0,
    salePrice: 89.99,
    image: "https://images.unsplash.com/photo-1556228720-195a672e8a03?w=400",
    rating: 4.9,
    reviews: 3201,
    description: "Night serum for visible renewal and hydration.",
    sizes: ["30ml", "50ml", "75ml"],
    colors: [],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "39",
    name: "Jo Malone Wood Sage & Sea Salt Cologne",
    brand: "Jo Malone London",
    category: "Beauty",
    price: 152.0,
    image: "https://images.unsplash.com/photo-1541643600914-78b084683601?w=400",
    rating: 4.7,
    reviews: 1123,
    description: "Earthy, mineral cologne in signature bottle.",
    sizes: ["30ml", "100ml"],
    colors: [],
    inStock: true,
  },
  {
    id: "40",
    name: "Olaplex Hair Perfector No.3",
    brand: "Olaplex",
    category: "Beauty",
    price: 30.0,
    image: "https://images.unsplash.com/photo-1522338242992-e1a54906a8da?w=400",
    rating: 4.8,
    reviews: 2890,
    description: "At-home treatment to reduce breakage.",
    sizes: ["100ml"],
    colors: [],
    inStock: true,
    badge: "BEST SELLER",
  },
];

export const categories = [
  { id: "women", name: "Women", image: "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=400", count: 1250 },
  { id: "men", name: "Men", image: "https://images.unsplash.com/photo-1490578474895-699cd4e2cf59?w=400", count: 980 },
  { id: "kids", name: "Kids", image: "https://images.unsplash.com/photo-1503919545889-aef636e10ad4?w=400", count: 650 },
  { id: "home", name: "Home", image: "https://images.unsplash.com/photo-1484101403633-562f891dc89a?w=400", count: 1540 },
  { id: "shoes", name: "Shoes", image: "https://images.unsplash.com/photo-1460353581641-37baddab0fa2?w=400", count: 2100 },
  { id: "handbags", name: "Handbags", image: "https://images.unsplash.com/photo-1584917865442-de89df76afd3?w=400", count: 450 },
  { id: "jewelry", name: "Jewelry", image: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=400", count: 890 },
  { id: "beauty", name: "Beauty", image: "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=400", count: 1780 },
];

export const navCategories = [
  { id: "women", name: "Women", subcategories: ["Dresses", "Tops", "Pants", "Jeans", "Coats", "Activewear"] },
  { id: "men", name: "Men", subcategories: ["Suits", "Shirts", "Pants", "Jeans", "Coats", "Activewear"] },
  { id: "kids", name: "Kids", subcategories: ["Girls", "Boys", "Baby", "Shoes", "Toys"] },
  { id: "home", name: "Home", subcategories: ["Bedding", "Bath", "Kitchen", "Furniture", "Decor"] },
  { id: "shoes", name: "Shoes", subcategories: ["Women's Shoes", "Men's Shoes", "Kids' Shoes", "Athletic"] },
  { id: "handbags", name: "Handbags", subcategories: ["Totes", "Crossbody", "Shoulder Bags", "Clutches"] },
  { id: "jewelry", name: "Jewelry", subcategories: ["Necklaces", "Earrings", "Bracelets", "Rings"] },
  { id: "beauty", name: "Beauty", subcategories: ["Skincare", "Makeup", "Fragrance", "Hair Care"] },
];
